import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
  name: 'naFallback',
  standalone: true,
  pure: false,
})

export class NaFallbackPipe implements PipeTransform {  

  transform(value: any): string {
    const lang = localStorage.getItem('lang');

    if (value) {
      return value;
    } else {
      try {
        if (lang === 'en') {
          return 'NA';
        } else {
          return "لا ينطبق";
        }
      } catch (error) {
        console.error('Translation error:', error);
        return 'NA';
      }
    }
  }
}
